import * as  React from 'react';
import {RequestData} from '@models/axios';
import {Modal, Button} from "antd";
import {ReactElement, ReactNode, Fragment} from "react";
import {FormattedMessage} from 'react-intl';


interface ModalFormProps {
  className: string;
  toggleButton: ReactElement;
  createRequest: (requestData: RequestData) => any;
  updateRequest: (requestData: RequestData) => any;
  // location:object;
}


/**
 * This class render a form inside it ..and handle common method
 * Handles: showModal , hideModal, onSuccess and on error callbacks , call update or create based on id
 * @param Component
 * Gets Error from errorCallback and pass it to the wrapped form to show error message
 * @constructor
 */

const ModalForm = <P extends object>(Component: React.ComponentType<P>) =>
  class ModalForm extends React.Component<P & ModalFormProps> {
    state = {
      visible: false,
      error: null,
      loading: false
    };
    
    private formRef?: ReactNode;
    
    setFormRef = (element: ReactNode) => {
      this.formRef = {
        current: element
      };
    };
    
    // formRef = React.createRef();
    
    showModal = () => {
      this.setState({
        visible: true
      });
    };
    
    handleCancel = () => {
      this.setState({
        visible: false,
        loading: false
      });
    };
    
    handleError = (error) => {
      const error_fields = error.data.meta.fields;
      //TODO inject errors in the form
      this.setState({
        loading: false,
        error_fields
      });
    };
    
    
    /**
     * Gets values form form component and handle create and update request
     * Detect update by checking Id existence in values
     * @param e
     */
    onOk = e => {
      const { payload, id, patch=false } = this.formRef.current.getValues();
      if (!payload) {
        console.log("Received error of form: ", payload);
        return
      }
      this.setState({
        loading : true
      });
      const requestDate = {
        payload: payload,
        patch,
        onSuccessCallback: () => this.handleCancel(),
        onErrorCallback: (error) => this.handleError(error),
      };
      if (id) {
        this.props.updateRequest({
          ...requestDate,
          params: {
            id
          }
        })
      }
      else {
        this.props.createRequest(requestDate)
      }
    };
    
    render() {
      return (
        <Fragment>
          <span onClick={this.showModal}>
              {this.props.toggleButton}
          </span>
          <Modal
            className={`form-modal ${this.props.className || ""}`}
            destroyOnClose={true}
            visible={this.state.visible}
            closable={this.state.loading ?  false : true}
            maskClosable={false}
            footer={[
              <Button key="back" onClick={this.handleCancel} disabled={this.state.loading}>
                <FormattedMessage id="app.cancel" defaultMessage={`Cancel`}/>
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={this.state.loading}
                onClick={this.onOk}
              >
                <FormattedMessage id="app.save" defaultMessage={`Save`}/>
              </Button>
            ]}
            onCancel={this.handleCancel}>
            
            <Component {...this.props as P}
                       error_fields={this.state.error_fields}
                       wrappedComponentRef={this.setFormRef}/>
          
          </Modal>
        </Fragment>
      )
      
    }
  };

export default ModalForm;